module.exports = __webpack_public_path__ + "img/avatar.e8f28de6.png";